"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var client_1 = __importDefault(require("react-dom/client"));
var google_1 = require("@react-oauth/google");
var appConfig_1 = __importDefault(require("./config/appConfig"));
require("./index.scss");
var app_1 = __importDefault(require("./app"));
require("./i18n/index");
var vconsole_1 = __importDefault(require("vconsole"));
require("./asset/font/IBMPlexSansThai/font.css");
// MobX runtime verification on the init stage
if (!Object.prototype.propertyIsEnumerable.call(new (/** @class */ (function () {
    function class_1() {
        Object.defineProperty(this, "x", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    return class_1;
}()))(), "x")) {
    throw new Error("Transpiler is not configured correctly");
}
// Create Root DOM for the app
var root = client_1.default.createRoot(document.getElementById("root"));
console.log("env.DEBUG_LOG", appConfig_1.default.getDebugLog());
if (appConfig_1.default.getDebugLog()) {
    new vconsole_1.default();
}
var Checkpoint = "Build 1.21a";
console.log("Build Checkpoint:", Checkpoint);
console.log("location?.href: ", location === null || location === void 0 ? void 0 : location.href);
// Main rendering, App module inside router
var googleClientID = appConfig_1.default.getGoogleClientId();
var appElement = (0, jsx_runtime_1.jsx)(app_1.default, {});
if (!googleClientID) {
    console.warn("Google OAuth is disabled because no GOOGLE_CLIENT_ID was found");
}
root.render(googleClientID ? ((0, jsx_runtime_1.jsx)(google_1.GoogleOAuthProvider, { clientId: googleClientID, children: appElement })) : (appElement));
